import { render, staticRenderFns } from "./TierModal.vue?vue&type=template&id=5180375d&"
import script from "./TierModal.vue?vue&type=script&lang=js&"
export * from "./TierModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5180375d')) {
      api.createRecord('5180375d', component.options)
    } else {
      api.reload('5180375d', component.options)
    }
    module.hot.accept("./TierModal.vue?vue&type=template&id=5180375d&", function () {
      api.rerender('5180375d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/coLiving/components/TierModal.vue"
export default component.exports